import * as z from "zod";

export const markConfigurationPushed = {
  name: "markConfigurationPushed" as const,
  input: z.object({
    merchantId: z.string(),
    product: z.enum(["returns", "order-editing"]).default("returns"),
  }),
  output: z.object({ success: z.boolean() }),
};

export type MarkConfigurationPushedInput = z.infer<
  typeof markConfigurationPushed.input
>;
export type MarkConfigurationPushedOutput = z.infer<
  typeof markConfigurationPushed.output
>;
